import UAParser from 'ua-parser-js';
export const DetectUserAgent = new UAParser();

export const isSafariBrower = DetectUserAgent.getBrowser().name === 'Safari';
